import * as React from "react"
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function KYCPhotoCamera(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={64}
            height={64}
            viewBox="0 0 64 64"
            fill="none"
            {...props}
        >
            <Circle cx={32} cy={32} r={32} fill="#E6F7E9" />
            <G filter="url(#filter0_d_4739_11381)">
                <Circle cx={31.9998} cy={31.9993} r={20.9778} fill="#fff" />
                <Circle
                    cx={31.9998}
                    cy={31.9993}
                    r={20.7278}
                    stroke="#E0E1E6"
                    strokeWidth={0.5}
                />
            </G>
            <G clipPath="url(#clip0_4739_11381)">
                <Path
                    d="M44 27.338v12.515c-.054.26-.039.537-.165.78a2.236 2.236 0 01-.995.989c-.406.205-.845.272-1.294.272H24.352c-.68 0-1.36.01-2.038-.004-.688-.014-1.294-.227-1.785-.744a1.734 1.734 0 01-.506-1.157c0-.047.01-.094-.023-.136V27.291c.073-.27.042-.566.194-.818.46-.766 1.143-1.16 2.03-1.17 1.257-.014 2.514-.003 3.771-.004h.234c.401-.01.516-.1.492-.505-.047-.92.665-1.798 1.852-1.793 1.999.008 3.997 0 5.995.004.422 0 .842-.02 1.263.034.844.109 1.475.886 1.444 1.667v.118c.011.375.102.471.48.474 1.125.006 2.247 0 3.371.004.359 0 .72-.033 1.074.044.734.159 1.307.536 1.642 1.228.115.24.105.51.159.764z"
                    fill="#8AD19A"
                />
                <Path
                    d="M41.546 41.893c.45 0 .888-.066 1.293-.272.131-.03.513-.33.64-.475h-22.95c.491.517 1.097.73 1.785.744.678.014 1.359.003 2.038.003h17.194z"
                    fill="#D7F2DB"
                />
                <Path
                    d="M26.134 33.565a5.863 5.863 0 015.89-5.856c3.255.008 5.897 2.661 5.88 5.904-.017 3.243-2.687 5.886-5.925 5.865a5.893 5.893 0 01-5.845-5.913z"
                    fill="#fff"
                />
                <Path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27.603 37.478a5.87 5.87 0 004.376 2c3.238.021 5.908-2.622 5.925-5.865a5.852 5.852 0 00-1.929-4.372 5.838 5.838 0 011.464 3.9c-.017 3.242-2.688 5.886-5.925 5.864a5.86 5.86 0 01-3.911-1.527z"
                    fill="#D7F2DB"
                />
                <Path
                    d="M39.403 28.816a1.175 1.175 0 011.173-1.175 1.173 1.173 0 11-1.173 1.175z"
                    fill="#fff"
                />
                <Path
                    d="M36.694 33.666c-.018 2.575-2.145 4.663-4.727 4.642-2.549-.024-4.647-2.143-4.642-4.69.004-2.588 2.151-4.71 4.741-4.683 2.599.024 4.647 2.118 4.628 4.73z"
                    fill="#8AD19A"
                />
                <Path
                    d="M28.79 33.59a3.223 3.223 0 116.446-.007 3.223 3.223 0 01-6.447.007z"
                    fill="#fff"
                />
                <Path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M29.398 35.474a3.223 3.223 0 104.47-4.523 3.224 3.224 0 01-4.47 4.523z"
                    fill="#F9F9FB"
                />
            </G>
            <Defs>
                <ClipPath id="clip0_4739_11381">
                    <Path
                        fill="#fff"
                        transform="translate(20 23)"
                        d="M0 0H24V18.8964H0z"
                    />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default KYCPhotoCamera
